/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {Location} from "../model/Location";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable()
export class LocationsService {

  private readonly locationUrl: string;
  constructor(private http: HttpClient) {
    this.locationUrl = inject(APP_CONFIG).baseUrl + '/api/locations';
  }

  getAll(): Observable<Location[]> {
    const url = `${this.locationUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(locations => locations as Location[]));
  }

  search(siteId: number, typeId: number): Observable<Location[]> {
    const url = `${this.locationUrl}/search/${siteId},${typeId}`;
    return this.http.get(url, httpOptions).pipe(
      map(locations => locations as Location[]));
  }

  getLocationById(locationId:number): Observable<Location> {
    const url = `${this.locationUrl}/${locationId}`;
    return this.http.get(url, httpOptions).pipe(
      map(location => location as Location));
  }

  addNew(newLocation: Location): Observable<Location> {
    const url = `${this.locationUrl}`;
    return this.http.post(url, newLocation, httpOptions).pipe(
      map( newLocation => newLocation as Location));
  }

  updateLocations(location: Location): Observable<Location> {
    var url = `${this.locationUrl}/${location.locationId}`;
    return this.http.put(url, location, httpOptions).pipe(
      map( location => location as Location ));
  }


}
